import { IdleModal } from '../model/datatype';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export const IdleTimeOutModal = (props: IdleModal) => {
  return (
    <Modal
      show={props.showModal}
      onHide={props.handleContinue}
      className="custom-modal"
    >
      {/* <Modal.Header closeButton>
            <Modal.Title>!Notify Session Expired </Modal.Title>
            </Modal.Header> */}
      <Modal.Body>Your session is Timed Out. You want to stay?</Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={props.handleLogout}>
          Logout
        </Button>
        <Button variant="primary" onClick={props.handleContinue}>
          Continue Session
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
